import React from 'react';
import CourseSection from './CourseSection';
import RatingsSection from './RatingsSection';
import CallToActionCard from "../CallToActionCard/CallToActionCard";
import './CourseContent.css';

const CourseContent = React.memo(({
  selectedGuide,
  setSelectedGuide,
  selectedHole,
  setSelectedHole,
  clubData,
  unit,
  onUnitToggle
}) => {
  return (
    <div className="Components">
      <CourseSection
        selectedGuide={selectedGuide}
        setSelectedGuide={setSelectedGuide}
        selectedHole={selectedHole}
        setSelectedHole={setSelectedHole}
        unit={unit}
        onUnitToggle={onUnitToggle}
        clubData={clubData}
      />
      
      <CallToActionCard />

      <RatingsSection
        selectedGuide={selectedGuide}
        setSelectedGuide={setSelectedGuide}
        clubData={clubData}
      />
    </div>
  );
});

CourseContent.displayName = 'CourseContent';

export default CourseContent; 